import React from "react";

const CheckboxRender = (props) => {
    const checkedHandler = (event) => {
        let colId = props.column.colId;
        const listSelectedValues = [];
        props.node.setDataValue(colId, event.target.checked);

        // Récupération des valeurs sélectionnées
        props.api.forEachNode((node) => {
            if (node.data.selected) {
                listSelectedValues.push(node.data);
            }
        });

        props.setGridSelectedValues(listSelectedValues);
    }

    const onChangeHandler = () => {}

    return (
        <input
            type='checkbox'
            onChange={onChangeHandler}
            onClick={checkedHandler}
            checked={props.value || false}
        />
    );

}

export default CheckboxRender;